import{styled as a}from"@mui/material/styles";import o from"../../../../../Typography/Typography.js";const r=a(o,{name:"CarouselPagination",slot:"label"})((({theme:a})=>({marginRight:a.spacing(2)})));export{r as Label};
//# sourceMappingURL=styles.js.map
